
// Content filtering for tone boundaries
const INAPPROPRIATE_PATTERNS = [
  // Threats and violence
  /\b(kill|murder|hurt|harm|violence|attack|destroy)\b/i,
  /\b(threat|threaten|sue|lawsuit|legal action)\b/i,
  
  // Extreme aggression
  /\b(hate|despise|disgusting|pathetic|worthless)\b/i,
  /\b(stupid|idiot|moron|dumb)\b/i,
  
  // Profanity (basic patterns)
  /\b(damn|hell|crap)\b/i,
  /f[u*]+ck/i,
  /sh[i*]+t/i,
  
  // Inappropriate demands
  /\b(demand|require|must)\s+(immediate|instant|now)\b/i,
  /\b(or else|consequences|regret)\b/i,
];

const BOUNDARY_SUGGESTIONS = {
  threats: "Consider using firm but professional language instead of threats",
  aggression: "Try expressing your frustration in a constructive way",
  profanity: "Professional language will be more effective with customer service",
  demands: "Polite requests tend to get better responses than demands"
};

export interface ToneValidationResult {
  isValid: boolean;
  issues: string[];
  suggestions: string[];
  filteredContent?: string;
}

export function validateToneContent(content: string): ToneValidationResult {
  const issues: string[] = [];
  const suggestions: string[] = [];
  let filteredContent = content;
  
  // Check for inappropriate patterns
  INAPPROPRIATE_PATTERNS.forEach(pattern => {
    if (pattern.test(content)) {
      if (pattern.source.includes('kill|murder|hurt|harm')) {
        issues.push('threats');
        suggestions.push(BOUNDARY_SUGGESTIONS.threats);
      } else if (pattern.source.includes('hate|despise|stupid')) {
        issues.push('aggression');
        suggestions.push(BOUNDARY_SUGGESTIONS.aggression);
      } else if (pattern.source.includes('f[u*]|sh[i*]')) {
        issues.push('profanity');
        suggestions.push(BOUNDARY_SUGGESTIONS.profanity);
      } else if (pattern.source.includes('demand|require|must')) {
        issues.push('demands');
        suggestions.push(BOUNDARY_SUGGESTIONS.demands);
      }
    }
  });
  
  // Filter out inappropriate content for AI processing
  if (issues.length > 0) {
    // Basic content filtering - replace problematic words
    filteredContent = content
      .replace(/\b(kill|murder|hurt|harm)\b/gi, 'resolve')
      .replace(/\b(hate|despise)\b/gi, 'dislike')
      .replace(/\b(stupid|idiot|moron)\b/gi, 'unreasonable')
      .replace(/\b(demand|require)\b/gi, 'request')
      .replace(/f[u*]+ck/gi, '[filtered]')
      .replace(/sh[i*]+t/gi, '[filtered]');
  }
  
  return {
    isValid: issues.length === 0,
    issues: [...new Set(issues)], // Remove duplicates
    suggestions: [...new Set(suggestions)],
    filteredContent: issues.length > 0 ? filteredContent : undefined
  };
}

export function shouldBlockGeneration(validation: ToneValidationResult): boolean {
  // Block if there are threats or severe profanity
  return validation.issues.includes('threats');
}
